var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22.0003,
    height: 18,
    viewBox: "0 0 22.0003 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.0001 4L12.0091 9.727C11.704 9.90421 11.3575 9.99755 11.0046 9.99755C10.6518 9.99755 10.3052 9.90421 10.0001 9.727L1.00013 4M3.00013 1H19.0001C20.1047 1 21.0001 1.89543 21.0001 3V15C21.0001 16.1046 20.1047 17 19.0001 17H3.00013C1.89556 17 1.00013 16.1046 1.00013 15V3C1.00013 1.89543 1.89556 1 3.00013 1Z",
    stroke: "#0F766E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationMail);
export default __webpack_public_path__ + "static/media/verification-mail.11f4b5b787d48f6ba6ecfcf0b6f03ae3.svg";
export { ForwardRef as ReactComponent };